import { error, FlowStepFragment } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const UpsertFlowStep = gql`
  mutation upsertFlowStep($input: UpsertFlowStepInput!) {
    upsertFlowStep(input: $input) {
      __typename
      ...FlowStepFragment
      ... on NoStepFound {
        id
      }
      ... on FlowCompleted {
        id
      }
      ... on UpsertFlowStepError {
        ...error
      }
    }
  }
  ${FlowStepFragment}
  ${error}
`;

export default UpsertFlowStep;
